<template>
    <div id="app">
        <modbus-config-app></modbus-config-app>
    </div>
</template>

<script>
import ModbusConfigApp from './components/modbus-config-app/ModbusConfigApp.vue'

export default {
    name: 'App',
    components: {
        'modbus-config-app': ModbusConfigApp
    }
}
</script>

<style lang="scss">
@import './assets/styles/custom-bootstrap.scss';
@import '../node_modules/bootstrap/scss/bootstrap.scss';

* {
    font-size: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue